/**
 * Route definition for /about
 * Renders the AboutContainer component (About Us page).
 *
 * @module routes/about
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import AboutContainer from "@/containers/About";

export const Route = createFileRoute('/$locale/about')({
  component: About,
})

/**
 * About page component.
 * Displays information about the Viri NFT Marketplace including tech stack,
 * development statistics, and project features.
 *
 * @returns {React.ReactElement}
 */
function About() {
  return (
    <>
      <AboutContainer />
    </>
  );
}
